import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { LOG_IN_COOKIE } from "../constants";
import { deleteCookie } from "../helpers/cookie";
import { useLang } from "../context/LangProvider";

const getSocialLabel = (type) => {
  switch (type) {
    case "KAKAO":
      return "카카오";
    case "NAVER":
      return "네이버";

    default:
      break;
  }
};

const TopBar = ({ onBack, i18n }) => {
  return (
    <header className="topbar">
      <div className="topbar__inner">
        <button
          className="topbar__back"
          onClick={onBack}
          aria-label={i18n("signin.nav.back.aria")}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M15 18l-6-6 6-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="topbar__back-text h6">{i18n("signin.nav.back")}</div>
        </button>
      </div>
    </header>
  );
};

const ExistingAccount = () => {
  const nav = useNavigate();
  const { i18n } = useLang();
  const location = useLocation();

  const user = location.state?.user;
  const isSocial = user?.attributes?.["custom:provider"];

  const [step, setStep] = useState(1);

  const handleBackPress = () => {
    if (step === 1) {
      handleSignin();
    } else {
      setStep(step - 1);
    }
  };

  const handleSignin = () => {
    deleteCookie(LOG_IN_COOKIE);
    nav("/");
  };

  return (
    <div className="signup">
      <TopBar onBack={handleBackPress} i18n={i18n} />
      <div className="find-account">
        <div className="h4 bold">{i18n("existing.title")}</div>

        <p className="brownDark70-color">
          {i18n("existing.desc.1")}
          <br />
          {i18n("existing.desc.2")}
        </p>

        <div
          className="account-box"
          style={{
            gap: "10px",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            padding: "15px",
          }}
        >
          <div className="h7 bold brownDark70-color">
            {isSocial
              ? `${getSocialLabel(isSocial)}${i18n("existing.via")}`
              : user?.attributes?.email}
          </div>
          <div className="tiny brownDark70-color">
            {moment(user?.createdAt).format("YYYY.MM.DD")}{" "}
            {i18n("existing.joined")}
          </div>
        </div>

        <div className="flex-center" style={{ gap: "15px", marginTop: "80px" }}>
          <button
            onClick={handleSignin}
            className="login__btn login__btn--primary"
          >
            {i18n("signin.cta.login")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExistingAccount;
